export const Feature = Object.freeze({
  PRICE_ALERTS: 'PRICE_ALERTS',
});

